export default __webpack_public_path__ + "static/Themanpreservingendangeredcolours-50341f3468f342f94f33a77e4236e473.jpg";